import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { PinFrequencyDocumentType } from "@/Common/Models/UI/Enums";
import { SendRequestStrategy } from "@/Labs/Services/Portal/Strategies/SendRequestStrategy";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class ConsultationRequestSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("ConsultationRequestLabel");
    }

    public getItemIconClass(): string {
        return "requestIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(portalPopupModel: PortalPopupModel, onSignatureAccepted: () => void, onRemoveSignature: () => void): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return new SendRequestStrategy(
            PortalLinkedItemType.ConsultationRequest,
            portalPopupModel,
            () => onSignatureAccepted(),
            null,
            () => onRemoveSignature()
        );
    }

    public getPinFrequencyToken(loginPinFrequencyModel: LoginPinFrequencyModel): string {
        return loginPinFrequencyModel?.consultationRequestToken ?? "";
    }

    public getPinFrequencyDocumentType(): PinFrequencyDocumentType | null {
        return PinFrequencyDocumentType.ConsultationRequest;
    }
}

export { ConsultationRequestSharedItemProvider };
